import { useState } from 'react';
import { Button, Container, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Cargos from '../Cargos';
import { activoSelector } from '../gestionConcursoSlice';
import Requisitos from './Requisitos';

const PostulacionConcurso = (props) => {
  const activo = useSelector(activoSelector);

  const [showModal, setShowModal] = useState(false);
  const [cargoSel, setCargoSel] = useState(null);

  const handlePostular = (cargo) => {
    setCargoSel(cargo);
    setShowModal(true);
  };

  const handleConfirmarPostulacion = (values) => {
    const finalValue = {
      requisitosPuesto: [],
      requisitosConcurso: [],
    };
    Object.keys(values).forEach((key, idx) => {
      const metadata = key.split('_'); // 0 -> "req", 1 -> tipo, 2 -> id
      if (metadata[1] !== 'puesto') {
        finalValue.requisitosConcurso = [
          ...finalValue.requisitosConcurso,
          {
            idRequisitoLlamadoConcurso: metadata[2],
            cumple: values[key],
          },
        ];
      } else {
        finalValue.requisitosPuesto = [
          ...finalValue.requisitosPuesto,
          {
            idRequisitoPuesto: metadata[2],
            cumple: values[key],
          },
        ];
      }
    });
  };
  const handleCancelar = () => {
    setShowModal(false);
  };

  return activo !== null ? (
    <Container>
      <Cargos cargos={activo.puesto} rol="aspirante" onPostular={handlePostular} />

      {cargoSel && (
        <Modal
          show={showModal}
          size="lg"
          onHide={handleCancelar}
          onExited={() => setCargoSel(null)}>
          <Modal.Header>
            <h4>Requisitos excluyentes - {cargoSel.denominacion}</h4>
          </Modal.Header>
          <Modal.Body>
            <p className="text-warning" style={{ fontSize: 14 }}>
              ¡Recuerde tener su información curricular actualizada antes de proceder con la
              inscripción!
            </p>
            {cargoSel.requisitos.length > 0 && (
              <h6>Indique a continuación el cumplimiento de los requisitos:</h6>
            )}
            <Requisitos
              requisitosConvocatoria={activo.requisitoLlamadoConcurso}
              requisitosPuesto={cargoSel.requisitos}
              onConfirmar={handleConfirmarPostulacion}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleCancelar}>Cancelar</Button>
            <Button type="submit" form="formRequisitos">
              Postularse
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  ) : null;
};

export default PostulacionConcurso;
